import { useSelector } from "react-redux";
import { extractValue } from "./utils";

export const useClientEmployment = () => {
  const { clientData } = useSelector((state) => state.Client);

  return {
    businessName: extractValue(clientData, "businessName"),
    employerPhone: extractValue(clientData, "employerPhone"),
    employmentBasis: extractValue(clientData, "employmentBasis"),
    dateStarted: extractValue(clientData, "dateStarted"),
  }
};